// src/lib/http/retiredCookies.ts
// Legacy shim, delete at S52: the pre-gateway build left these JavaScript-readable cookies behind for up to 7 days.

import Cookies from "js-cookie";

// Contract §3 retires all three; nothing reads them, and removing them takes a stale bearer out of every script's reach.
export const RETIRED_COOKIES = ["apiKey", "user", "subscriptions"] as const;

export const purgeRetiredCookies = (): void => {
	RETIRED_COOKIES.forEach((name) => Cookies.remove(name));
};
